import {
    SET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED
} from "./AssetItemStatusVendorDetailType"

const initialState = {
    assetItemStatusVendorDetail: [],
    loadingStates: {} as any 
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_ASSET_ITEM_STATUS_VENDOR_DETAIL) {
        return {
            ...state,
            assetItemStatusVendorDetail: action.assetItemStatusVendorDetail,
        };
    }
    else if (action.type === SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED) {
        const { fleetDetailId, isLoading } = action;
        return {
            ...state,
            loadingStates: {
                ...state.loadingStates,
                [fleetDetailId]: {
                    ...state.loadingStates[fleetDetailId],
                    isLoading: isLoading
                }
            }
        }
    }
    else {
        return state;
    }
};

export default reducer;